import React from "react";

/**
 * Spinning wheel arrow pointer icon
 * Points downward to indicate the winning segment
 */
export const WheelArrowIcon: React.FC = () => {
  return (
    <svg width={30} height={40} viewBox="0 0 30 40" className="drop-shadow-lg">
      {/* White border/outline */}
      <path d="M28 2 L2 20 L28 38 Z" fill="white" stroke="white" strokeWidth="2" strokeLinejoin="round" />
      {/* Blue arrow */}
      <path
        d="M26 5 L5 20 L26 35 Z"
        fill="var(--color-cede-primary)"
        stroke="var(--color-cede-primary-dark)"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  );
};
